import { sanitizeOpeningTimesRange } from './'

export const setLocalBusinessData = (market, location, ogImage) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Store',
    image: ogImage,
    '@id': location.origin,
    name: market?.name,
    address: {
      '@type': 'PostalAddress',
      streetAddress: market?.address?.street,
      addressLocality: market?.address?.city,
      postalCode: market?.address?.zip,
      addressCountry: 'DE'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: market?.address?.lat,
      longitude: market?.address?.lon
    },
    url: location.href,
    telephone: market?.contact?.phone,
    openingHoursSpecification: sanitizeOpeningTimesRange(
      market?.openingHoursMarket
    )
  }
}
